import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ESignature } from '../model/e-signature/e-signature';
import { DemanderESignature } from '../model/e-signature/demander-e-signature';

@Injectable({
    providedIn: 'root'
  })
  export class ESignatureService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findAllByRequest(requestId) {
        return this._restClientService.load<ESignature[]>('e-signature/find-all-by-request/'+requestId);
    }
    
    add(demanderSignature: DemanderESignature) {
        return this._restClientService.save<void>('e-signature/create', demanderSignature);
    }
  
    recevoirByESignatureId(esignatureid) {
        return this._restClientService.load<ESignature>('e-signature/recevoir-by-esignatureid?esignatureid='+esignatureid);
    }
    
  }